import type { Annotation } from "building-types/annotation/annotationTypes";
import type { ViewportParameterValues } from "building-types/systemParameterTypes";
import type { Table } from "common/data/table";
import { sheetInchesNew } from "common/utils/nominalNumbers";
import { PlacementXAnchor, PlacementYAnchor } from "common/utils/textAlignment";
import { parameterTokenNew } from "doc/parameterTools";
import { lineworkNew, noteNew } from "doc/utils/annotation";
import { arc2ByCenterStartAngle } from "geom/arc";
import { TWO_PI } from "geom/core";
import { polyLine2New } from "geom/polyLine2Types";

function viewportParameterToken(paramId: keyof ViewportParameterValues): string {
  return parameterTokenNew(paramId);
}

export function generateDefaultViewportTitleAnnotation(): Table<Annotation> {
  const viewportNumberBubble = lineworkNew({
    path: arc2ByCenterStartAngle(0.25, -0.5, 0, -0.5, TWO_PI),
    name: "Viewport Number Bubble",
    id: "viewportNumberBubble",
    lineWeight: 3,
    sortIndex: 0,
  });

  const divider = lineworkNew({
    path: polyLine2New([0.5, -0.5, 4.5, -0.5]),
    name: "Divider",
    id: "divider",
    lineWeight: 5,
    sortIndex: 1,
  });

  const viewportScale = noteNew({
    text: viewportParameterToken("viewportScale"),
    name: "Viewport Scale",
    id: "viewportScale",
    fontSize: sheetInchesNew(0.1875),
    x: 0.5625,
    y: -0.6875,
    sortIndex: 2,
  });

  const viewportName = noteNew({
    text: viewportParameterToken("viewportName"),
    name: "Viewport Name",
    id: "viewportName",
    fontSize: sheetInchesNew(0.1875),
    x: 0.5625,
    y: -0.3125,
    sortIndex: 3,
  });

  const viewportNumber = noteNew({
    text: viewportParameterToken("viewportNumber"),
    name: "Viewport Number",
    id: "viewportNumber",
    fontSize: sheetInchesNew(0.1875),
    x: 0.25,
    y: -0.5,
    sortIndex: 4,
    placementXAnchor: PlacementXAnchor.CENTER,
    placementYAnchor: PlacementYAnchor.CENTER,
  });

  return {
    [viewportNumberBubble.id]: viewportNumberBubble,
    [divider.id]: divider,
    [viewportScale.id]: viewportScale,
    [viewportName.id]: viewportName,
    [viewportNumber.id]: viewportNumber,
  };
}
